//import axios from 'axios';
//import { put, call, select } from 'redux-saga/effects';

function* signOut (action, state) {
  // Code here  
};

export default signOut;